import { cn, type PropsWithClassName } from "@/components/podkit/lib/cn";
import { type VariantProps, cva } from "class-variance-authority";
import { forwardRef } from "react";

const variants = cva("min-w-[20px] rounded-[10px] px-[6px] py-[2px] font-bold font-mono text-sm text-center", {
    variants: {
        variant: {
            default: "bg-surface-brand text-content-brand dark:bg-content-brand/25 dark:text-surface-brand/80",
            muted: "bg-surface-accent text-content-strong",
        },
    },
});

export type NotificationVariant = VariantProps<typeof variants>["variant"];

export type NotificationProps = {
    content: string;
} & VariantProps<typeof variants> &
    PropsWithClassName;

export const Notification = forwardRef<HTMLSpanElement, NotificationProps>(
    ({ content, variant, className, ...props }, ref) => {
        return (
            <span ref={ref} className={cn(variants({ variant: variant ?? "default" }), className)} {...props}>
                {content}
            </span>
        );
    },
);

Notification.displayName = "Notification";
